import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Box
} from '@mui/material';
import api from '../../services/api';

const PersonEditModal = ({ open, onClose, person, onPersonUpdated }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    heightInCentimeters: ''
  });

  useEffect(() => {
    if (person && open) {
      setFormData({
        firstName: person.firstName || '',
        lastName: person.lastName || '',
        heightInCentimeters: person.heightInCentimeters || ''
      });
      setError('');
    }
  }, [person, open]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    setError('');

    // Validatie
    if (!formData.firstName.trim()) {
      setError('Voornaam is verplicht.');
      return;
    }

    if (!formData.lastName.trim()) {
      setError('Achternaam is verplicht.');
      return;
    }

    setLoading(true);
    try {
      const response = await api.put(`/persons/${person.id}`, {
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        heightInCentimeters: formData.heightInCentimeters ? parseInt(formData.heightInCentimeters) : 0
      });

      if (response.status === 200) {
        onPersonUpdated(response.data);
        onClose();
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Fout bij het opslaan van gegevens.');
      console.error('Error updating person:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Persoonsgegevens wijzigen</DialogTitle>
      
      <DialogContent sx={{ pt: 2 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            fullWidth
            label="Voornaam"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            variant="outlined"
            disabled={loading}
          />

          <TextField
            fullWidth
            label="Achternaam"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            variant="outlined"
            disabled={loading}
          />

          <TextField
            fullWidth
            label="Lengte (cm)"
            name="heightInCentimeters"
            type="number"
            value={formData.heightInCentimeters}
            onChange={handleInputChange}
            variant="outlined"
            inputProps={{ min: 0, step: 1 }}
            disabled={loading}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Annuleren
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Opslaan'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PersonEditModal;
